<style scoped lang="less">
    //@import './index.less';
    .layout{
        //background: #2E3660;
        position: relative;
        overflow: hidden;
        display: flex;
        &-logo{
            width: 100px;
            height: 30px;
            background: #5b6270;
            border-radius: 3px;
            float: left;
            position: relative;
            top: 15px;
            left: 20px;
        }
        &-nav{
            width: 420px;
            margin: 0 auto;
            margin-right: 20px;
        }
        &-header{
            //position: fixed;
             width: 100%;
             background:#fff;
             border-bottom: 1px solid rgba(0,0,0,0.15);
        }
        &-sider{
            background: #1F2232;
            position: fixed;
             height: 100vh;
             left: 0;
             box-shadow: 2px 0 6px 0 rgba(0,0,0,.1);
             overflow: auto;
        }
    }
    .menu-title{
        height: 70px;
        line-height:70px;
        background: #fff;
        color: rgba(0,0,0,0.85);
        padding:0 32px;
        font-size: 20px;
    }
    .logo-con{
        font-size:16px;
        color:#fff;
        height: 64px;
        line-height: 64px;
        text-align:center;
        background: #2E3660;
        img{
            height: 24px;
            width: auto;
            margin-right: 10px;
            vertical-align: middle;
        }
    }
  .layout-content{
    //height: e("calc(100vh - 134px)");
  }
</style>
<template>
    <div class="layout">
        <Sider hide-trigger class="layout-sider">
            <div class="logo-con">
                <img src="../images/logo.png">Fancy视觉处理系统
            </div>
            <f-menu :menu-list="menuList" :open-names="openNames"></f-menu>
        </Sider>
        <Layout style="padding-left: 200px;">
            <Header class="layout-header">
                <Row type="flex" justify="space-between">
                    <div></div>
                    <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown">
                        <a href="javascript:void(0)">
                            <span class="main-user-name">{{ userName }}</span>
                            <Icon type="arrow-down-b"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem name="loginout">退出登录</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </Row>
            </Header>
            <Layout :style="{minHeight: '100vh',width:'100%'}">
                <div style="width: 100%;">
                    <Layout>
                      <div class="menu-title">
                        {{menuTitle}}
                      </div>
                      <Content class="layout-content">
                          <router-view></router-view>
                      </Content>
                    </Layout>
                </div>
            </Layout>
        </Layout>
    </div>
</template>
<script>
import Menu from '@/components/layout/menu'
import * as router  from '@/router'

export default {
    data() {
        return {
            userName: 'admin',
            avatorPath: ''
        }
    },
    computed: {
        cachePage() {
            //return this.$store.state.app.cachePage
        },
        currentPath() {
            //return this.$store.state.app.currentPath // 当前面包屑数组
        },
        menuList() {
            return router.appRouter
        },
        menuTitle() {
          return this.$route.meta.title
        },
        openNames(){
            return ['transcoding','cutout']
            let openNames = []
            router.appRouter.forEach(r=>{
                if(r.name == this.$route.name){
                    openNames.push(r.name)
                    return false
                }else{
                    r.children && r.children.forEach(c=>{
                        if(c.name == this.$route.name){
                            openNames.push(c.name)
                            openNames.push(r.name)
                            return false
                        }
                    })
                }
            })
            //return openNames
        }
    },
    mounted(){
        if(!/fvs=/.test(document.cookie)){
            this.$router.push({
              path:'/login'
            })
        }
    },
    methods: {
        handleClickUserDropdown(name) {
            if(name === 'loginout'){
                document.cookie = "fvs=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                this.$router.push({
                  path:'/login'
                })
            }
        }
    },
    components: {
        'f-menu':Menu
    }
}
</script>
